import { MapsLocation } from './maps-location.model';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
declare var google: any;

@Component({
  selector: 'app-maps-search',
  templateUrl: './maps-search.component.html'
})
export class MapsSearchComponent implements OnInit, OnChanges {
  @Input() location: MapsLocation;
  @Input() label = 'Location';
  @Input() placeholder = 'Type to search location';
  @Input() name = 'maps-location';
  @Output() found = new EventEmitter<MapsLocation>(null);
  @Input() value = '';
  result: MapsLocation;
  map;
  geocoder;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (changes['location']) {
      this.result = changes['location'];
    }
  }

  find(value) {
    if (!value) {
      this.reset();
    } else if (!(this.geocoder && this.map && google)) {
      return;
    } else {
      this.geocoder.geocode({ address: value}, (results, status) => {
        if (status === 'OK') {
          this.result = results.map(r => ({
            latitude: r.geometry.location.lat(),
            longitude: r.geometry.location.lng(),
            name: r.formatted_address
          }))[0];

          this.found.emit(this.result);
        }
      });
    }
  }

  reset() {
    this.value = '';
    this.result = null;
    this.location = null;
    this.found.emit(this.result);
  }

  getMap(map) {
    this.map = map;
    this.geocoder = new google.maps.Geocoder();
  }

}
